import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  Optional,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DialogData, EbwModalService } from '@ebw-monorepo/modal';
import { lastValueFrom } from 'rxjs';
import { FilesystemService } from '../../../../services/filesystem.service';
import { ITEMSICON, Icon, TreeNode } from './models/tree-models';
import { safeJsonParse, safeJsonStringify } from '@ebw-monorepo/microservices-helpers/utils/parser';

@Component({
  selector: 'app-fascicolo-elettronico',
  templateUrl: './psa-filesystem.component.html',
  styleUrls: ['./psa-filesystem.component.scss']
})
export class PsaFileSystemComponent implements OnInit {
  @Input() url: string = '';
  folder: TreeNode = null;
  @ViewChildren('listItem') listItems: QueryList<ElementRef>;
  @ViewChild('searchContainer', { static: false }) searchContainer: ElementRef;
  @ViewChild('navigationContainer', { static: false }) navigationContainer: ElementRef;

  nodes: TreeNode[] = [];
  activeNodes: TreeNode[] = [];
  resetSearchNodes: TreeNode[] = [];
  selectedNodes: TreeNode[] = [];
  itemsIcon: Icon[] = ITEMSICON;
  activeNode: TreeNode;
  selectedNode: TreeNode;
  folderElement: number = 0;
  searchTerm: string = '';
  activeToolbarAction: boolean = false;
  moveFiletoggle: boolean = false;
  fileUpload: ElementRef;

  constructor(
    public dialog: MatDialog,
    public fsService: FilesystemService,
    private modalService: EbwModalService,
    @Optional() @Inject(MAT_DIALOG_DATA) public matData: DialogData
  ) {}

  ngOnInit() {
    this.folder = this.matData['folder'];
    this.getNodes();
  }

  closeModal() {
    this.dialog.closeAll();
  }

  breadcrumbHandler = ($event: string) => this.breadcrumbFilter($event, this.nodes);
  activeNodesHandler = ($event: TreeNode[]) => (this.activeNodes = $event);
  folderElementHandler = ($event: number) => (this.folderElement = $event);
  moveFiletoggleHandler = ($event: boolean) => (this.moveFiletoggle = $event);
  iconActionHandler = ({ action, element }) => {
    this.fileUpload = element;
    this.callToolbarIconAction(action);
  };
  moveHandler = async ($event: boolean) => {
    if ($event) {
      this.moveFiles(this.selectedNodes, this.activeNode);
    }
  };
  nodesHandler = ($event: TreeNode) => {
    this.activeNode = $event ? $event : this.nodes[0];
    this.activeNodes = $event ? $event.children : this.nodes[0].children;
    this.resetSearchNodes = this.activeNodes;
    this.folderElement = this.activeNodes.length;
  };

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: EventTarget): void {
    if (this.activeToolbarAction && !this.moveFiletoggle) {
      if (!targetElement) {
        return;
      }

      let clickedInside = false;

      this.listItems.forEach((item) => {
        const listItemElement = item.nativeElement;
        if (listItemElement.contains(targetElement as Node)) {
          clickedInside = true;
          return;
        }
      });

      if (!clickedInside) {
        const parent = this.fsService.findParent(this.nodes[0], this.activeNode);
        if (parent) {
          if (this.activeNode && this.activeNode.type === 'file') {
            this.activeNode = parent;
          }
          this.activeToolbarAction = false;
          this.selectedNodes = [];
          // this.fsService.getSelectedNodes(this.toolbarIcon, this.selectedNodes);
        }
      }
    }
  }

  onRightClick(event: Event, obj: TreeNode) {
    event.preventDefault();
    if (obj.type === 'file') {
      return;
    }
  }

  async getNodes(silent = false) {
    // recupero strutura filesystem
    const res = await lastValueFrom(this.fsService.getFilesystem());

    if (silent) {
      return res;
    }

    this.nodes = [
      {
        id: null,
        name: 'Home',
        path: '',
        expanded: true,
        type: 'folder',
        children: res,
        isDeletable: true,
        isEditable: true
      }
    ];
    this.nodes = this.updatePaths(this.nodes);

    // ----------
    const findNode = (root: TreeNode, activeNodeId: string) => {
      if (root.id === activeNodeId) {
        return root;
      }

      if (root.children && root.children.length > 0) {
        for (let child of root.children) {
          let found = findNode(child, activeNodeId);
          if (found) {
            return found;
          }
        }
      }

      return null; // Nodo non trovato
    };
    // ----------

    // quando arrivo dal dettaglio elemento con un folder selezionato (solo al primo caricamento)
    if (this.folder && !this.activeNode) {
      this.activeNode = findNode(this.nodes[0], this.folder.id);
    }

    // se non ho selezionato nodi attivi parto dalla root
    if (!this.activeNode) {
      let activeNode: TreeNode;
      activeNode = this.nodes[0];
      return this.updateView(activeNode);
    }

    // Se il nodo attivo è una cartella
    if (this.activeNode.type === 'folder') {
      const node = findNode(this.nodes[0], this.activeNode.id);

      // activeNode = this.nodes[0].children.find((n) => n.name === this.activeNode.name);
      return this.updateView(node);
    }

    // if (this.activeNode.type === 'folder') {
    //   activeNode = this.nodes[0].children.find((n) => n.name === this.activeNode.name);
    //   return this.updateView(activeNode);
    // }

    // if (this.activeNode.type === 'file') {
    //   const folderName = this.activeNode.parentPath.split('/').filter(Boolean).reverse()[0];
    //   activeNode = this.nodes[0].children.find((n) => n.name === folderName);
    //   return this.updateView(activeNode);
    // }
  }

  updatePaths(nodes: TreeNode[], parentPath = '') {
    return nodes.map((node) => {
      if (node.type === 'file') {
        return node;
      }
      // Costruisci il nuovo percorso concatenando il percorso del padre con il nome del nodo
      const currentPath = parentPath ? `${parentPath}/${node.name}` : node.name;

      // Aggiorna il nodo con il nuovo percorso
      const updatedNode = { ...node, path: currentPath };

      // Se il nodo ha figli, aggiorna anche i loro percorsi
      if (updatedNode.children && updatedNode.children.length > 0) {
        updatedNode.children = this.updatePaths(updatedNode.children, currentPath);
      }

      return updatedNode;
    });
  }

  updateView(activeNode) {
    this.activeNodes = activeNode.children;
    this.resetSearchNodes = activeNode.children;
    this.activeNode = { ...activeNode };
    this.folderElement = this.activeNodes.length;
  }

  setActive(node: TreeNode) {
    if (node.type === 'folder') {
      this.openFolder(node);
    } else if (node.type === 'file') {
      this.fsService.openFile(node);
    } else {
      console.error('Tipo di nodo non gestito:', node.type);
    }
  }

  async callToolbarIconAction(action: string) {
    switch (action) {
      case 'upload':
        this.fileUpload.nativeElement.click();
        break;
      case 'download':
        this.fsService.download(this.selectedNodes[0]);
        break;
      case 'move':
        this.moveFiletoggle = true;
        this.selectedNode = this.activeNode;
        break;
      case 'delete':
        if (this.selectedNodes[0].type === 'folder') {
          this.deleteFolder(this.selectedNodes[0]);
          return;
        }
        this.deleteFiles(this.selectedNodes);
        break;

      default:
        this.selectedNodes =
          this.selectedNodes.length !== 0 ? [] : this.activeNodes.filter((node) => node.type === 'file');
        // this.fsService.getSelectedNodes(this.toolbarIcon, this.selectedNodes);
        break;
    }
  }

  handleItemClick(event, index, node) {
    if (node.type === 'folder') {
      if (!this.moveFiletoggle) {
        this.activeToolbarAction = false;
        this.selectedNodes = [];
        this.selectedNodes.push(node);
      }
    } else if (event.shiftKey) {
      const firstSelectedNode = this.selectedNodes.length !== 0 ? this.selectedNodes[0] : undefined;
      const firstSelectedNodeIndex = firstSelectedNode
        ? this.activeNodes.findIndex((node) => node === firstSelectedNode)
        : index;

      const selectedRange = this.activeNodes.slice(
        Math.min(index, firstSelectedNodeIndex),
        Math.max(index, firstSelectedNodeIndex) + 1
      );

      const tempSelect =
        selectedRange.length === 0
          ? [this.activeNodes[index]]
          : this.selectedNodes.length > 1
          ? selectedRange
          : [...new Set([...this.selectedNodes, ...selectedRange])];

      this.selectedNodes = tempSelect.filter((node) => node.type === 'file');
    } else {
      const alreadyIncludes = this.selectedNodes.includes(node);
      if (alreadyIncludes) {
        this.selectedNodes = this.selectedNodes.filter((n) => n !== node);
        this.selectedNodes.length === 0 && (this.activeToolbarAction = false);
      } else {
        this.selectedNodes.push(node);
        this.activeToolbarAction = true;
      }
    }
  }

  // ------------------------------------------------------------------------------------------------

  openFolder(node: TreeNode) {
    this.activeNodes = node.children;
    this.folderElement = node.children.length;
    this.activeNode = node;
    if (!this.moveFiletoggle) {
      this.selectedNodes = [];
    }
  }

  // ------------------------------------------------------------------------------------------------

  async upload($event) {
    // estraggo i file dal campo input
    const files = $event.target.files || $event.dataTransfer.files;
    // se non ci sono file non faccio niente
    if (!files || !files.length) {
      return;
    }
    // mi ricavo il mio file visato che abbiamo previsto un upload singolo
    const file = files[0] || null;

    try {
      await lastValueFrom(this.fsService.uploadFile(file, this.activeNode.id));
    } catch (error) {
      this.modalService.openErrorModal({ title: 'Errore caricamento file', content: error.error.message });
    }
    this.activeToolbarAction = false;
    this.moveFiletoggle = false;
    this.getNodes();
  }

  // ------------------------------------------------------------------------------------------------

  async deleteFolder(folder: TreeNode) {
    try {
      const response = await lastValueFrom(this.fsService.deleteFolder(folder.id));
      const message = { title: 'Eliminazione cartella', content: response.message };
      this.modalService.openInfoModal(message);
      this.selectedNodes = [];
      this.getNodes();
    } catch (error) {
      const message = { title: 'Eliminazione cartella', content: error.error.message };
      this.modalService.openInfoModal(message);
    }
  }

  // ------------------------------------------------------------------------------------------------

  async deleteFiles(files: TreeNode[]) {
    const promises = [];
    files.forEach((f: TreeNode) => {
      promises.push(lastValueFrom(this.fsService.deleteFile(f.id)));
    });
    const responses = await Promise.allSettled(promises);
    const messages = responses.map((r) =>
      (r as any).reason?.error ? (r as any).reason?.error.message : (r as any).value?.message
    );
    const message = { title: 'Eliminazione file', content: messages.join('<br>') };
    this.modalService.openInfoModal(message);
    this.selectedNodes = [];
    this.getNodes();
  }

  // ------------------------------------------------------------------------------------------------

  async moveFiles(filesToMove: TreeNode[], newFolder: TreeNode) {
    const cantMoveFile = filesToMove.some((f) => !f.isEditable);
    if (cantMoveFile) {
      const message = {
        title: 'Spostamento file',
        content: 'Alcuni dei file che hai selezionato non sono modificabili'
      };
      this.modalService.openInfoModal(message);
      this.selectedNodes = [];
      return;
    }
    const promises = [];
    filesToMove.forEach((f: TreeNode) => {
      promises.push(lastValueFrom(this.fsService.moveFile(f.id, newFolder.id)));
    });
    const responses = await Promise.allSettled(promises);
    const messages = responses.map((r) =>
      (r as any).reason?.error ? (r as any).reason?.error.message : (r as any).value?.message
    );
    const message = { title: 'Spostamento file', content: messages.join('<br>') };
    this.modalService.openInfoModal(message);
    this.selectedNodes = [];
    this.getNodes();
  }

  // ------------------------------------------------------------------------------------------------

  breadcrumbFilter($event: string, nodes: TreeNode[]) {
    for (let i = 0; i < nodes.length; i++) {
      let obj = nodes[i];

      if (obj.name === $event) {
        this.activeNode = obj;
        this.activeNodes = obj.children;
        return;
      }

      if (obj.children && obj.children.length > 0) {
        let risultatoRicorsivo = this.breadcrumbFilter($event, obj.children);
        if (risultatoRicorsivo) {
          return risultatoRicorsivo;
        }
      }
    }
  }

  // ------------------------------------------------------------------------------------------------

  onDragStart = ($event: any, node: TreeNode) => $event.dataTransfer.setData('node', safeJsonStringify(node, ''));

  // ------------------------------------------------------------------------------------------------

  onDropHandler = async ({ node, newFolder }: { node: TreeNode; newFolder: string }) => {
    if (!node.isEditable) {
      const message = {
        title: 'Spostamento file',
        content: 'Il file selezionato non è modificabile'
      };
      this.modalService.openInfoModal(message);
      return;
    }
    const newFolderNode = this.fsService.findNode(this.nodes[0], newFolder);
    await lastValueFrom(this.fsService.moveFile(node.id, newFolderNode.id));
    this.getNodes();
  };

  // ------------------------------------------------------------------------------------------------

  onDragOver = ($event: DragEvent) => {
    $event.preventDefault();
    $event.dataTransfer.dropEffect = 'move';
  };

  // ------------------------------------------------------------------------------------------------

  onDragLeave = ($event: DragEvent) => {
    $event.preventDefault();
  };

  // ------------------------------------------------------------------------------------------------

  onDrop($event: Event, nodeDropped?: TreeNode, elementDroped?: HTMLElement) {
    if (nodeDropped && nodeDropped.type === 'folder') {
      const node: TreeNode = safeJsonParse(($event as DragEvent).dataTransfer.getData('node'));
      if (!node) {
        return;
      }
      const newFolder = elementDroped.textContent.split('folder ').reverse()[0].trim();

      this.onDropHandler({ node, newFolder });
    } else if (!nodeDropped && !elementDroped) this.upload($event);
  }

  async openModalNewFolder() {
    const response = await this.fsService.openModalNewFolder({ folders: this.activeNodes }, this.activeNode.id);
    !!response && this.getNodes();
  }
}
